module.exports = __webpack_public_path__ + "img/calendar_input_icon.1a77772c.svg";